/**
 * @param {string} name
 * displayStationInitials
 * returns the initials of the first two space seperated name
 * of the string passed as its argument
 * @example
 *  displayStationInitials("hello world") -> "HW"
 * @returns {string}
 */
const displayStationInitials = (name) => {
  if (!name) {
    return '';
  }
  let displayedInitials = '';
  let splitName = name.toString().split(' ');
  if (splitName.length > 2) {
    displayedInitials += splitName[0].charAt(0);
    displayedInitials += splitName[1].charAt(0);
  } else {
    displayedInitials += splitName[0].charAt(0);
    displayedInitials += splitName[0].charAt(1);
  }
  return displayedInitials;
};

export default displayStationInitials;
